var _mask, _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCoverWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.927 11.055a5.27 5.27 0 0 1 4.184-6.094l2.012-.392.33 19.416a5.289 5.289 0 0 0 5.292 5.197l17.761-.016a2.376 2.376 0 0 1-1.93 2.755l-18.03 3.166a5.29 5.29 0 0 1-6.122-4.286L.927 11.055Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.123 4.57 2-.032-.04-2.388-2.345.457.385 1.962Zm.33 19.415-2 .032 2-.032ZM5.11 4.961l.385 1.963-.385-1.963Zm.385 1.963 2.012-.392-.77-3.925-2.012.391.77 3.926ZM5.123 4.6l.33 19.417 4-.063-.33-19.416-4 .062Zm7.627 26.582 17.761-.017-.01-3.999-17.76.017.009 3.999Zm15.478-1.23-18.032 3.166.698 3.938 18.032-3.165-.698-3.939Zm-21.834.503L2.897 10.71l-3.94.691 3.497 19.746 3.94-.692Zm22.143-.943a.38.38 0 0 1-.309.44l.698 3.939a4.373 4.373 0 0 0 3.55-5.071l-3.94.692ZM5.452 24.017a7.292 7.292 0 0 0 7.298 7.165l-.01-4a3.286 3.286 0 0 1-3.287-3.227l-4 .062Zm4.744 9.1a3.286 3.286 0 0 1-3.802-2.662l-3.94.692a7.293 7.293 0 0 0 8.44 5.91l-.698-3.94ZM4.726 2.999a7.267 7.267 0 0 0-5.769 8.403l3.94-.691a3.274 3.274 0 0 1 2.6-3.786l-.77-3.926Z",
    fill: "#fff",
    mask: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 26.329 4.118-5.19a2.112 2.112 0 0 1 3.194-.134l1.164 1.24a2.112 2.112 0 0 0 3.372-.397l2.754-4.807c.791-1.38 2.764-1.427 3.611-.08 2.229 3.538 5.67 9.027 5.779 9.368.161.504-2.847 2.671-2.847 2.671H8.357L7 26.329Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.024,
    y: 1,
    width: 23.976,
    height: 28.507,
    rx: 4.28,
    stroke: "#fff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.508 13.946a2.19 2.19 0 0 0 2.202-2.18 2.19 2.19 0 0 0-2.202-2.178 2.19 2.19 0 0 0-2.2 2.179 2.19 2.19 0 0 0 2.2 2.179Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCoverWhite);
export default __webpack_public_path__ + "static/media/add_cover_white.1e859dbd9080f2c1aceaa8abdf797de4.svg";
export { ForwardRef as ReactComponent };